<template>
  <!--创建EXT跟grid配对的按钮-->
  <el-dialog
    :title="$t('lang.addvideo')"
    :visible.sync="data.show"
    width="600px"
    :center="true"
    :close-on-click-modal="false"
    class="add-source-dialog uploadDate"
    @close="cancelUploadedVideo"
    :destroy-on-close="true"
  >
    <div class="content">
      <el-row>
        <el-col>
          <p class="item_title">
            <span>*</span>
            {{ $t("lang.Folder") }}
          </p>
          <el-input
            class="treeInput"
            suffix-icon="arrow-icon el-icon-arrow-top"
            v-model="flodLocation"
            @focus="showTree"
            readonly="readonly"
            :placeholder="$t('lang.selectFolder')"
          ></el-input>
          <div
            class="flodTree"
            v-if="showTreeFlag">
            <el-tree
              :data="mediaList"
              :props="mediaListProps"
              node-key="id"
              default-expand-all
              show-checkbox
              ref="tree"
              :check-strictly="true"
              @check="getCheckedKeys"
            >
              <span
                class="custom-tree-node"
                slot-scope="{ node, data }"
              >
                <span
                  class="f_left ellipsis"
                  :title="node.label">
                  <span
                    class="iconfont icon-Handle f_left ellipsis"
                    style="color: #33ab4f"
                    v-if="data.folderName ? true : false"
                  ></span>
                  {{ node.label }}
                </span>
              </span>
            </el-tree>
          </div>
        </el-col>
        <el-col
          :span="8"
          class="CoverWrap">
          <p class="item_title">{{ $t("lang.mediaFolder") }}</p>
          <div class="upload_p">
            <i class="el-icon-plus avatar-uploader-icon"></i>
            {{ $t("lang.upload") }}
            <el-upload
              ref="loadControl"
              class="upload"
              action="#"
              :on-change="handleChange"
              :on-remove="handleRemove"
              :show-file-list="false"
              :file-list="fileList"
              :multiple="false"
              :class="{ notAllowed: flodLocation == '' || fileList.length > 0 }"
              :disabled="flodLocation == '' || fileList.length > 0"
              accept=".ts,.rm,.rmvb,.wmv,.wtv,.avi,.3gp,.mkv,.mpg,video/mpeg,video/mp4,.mov"
              :http-request="uploadFileBySDK"
            >
            </el-upload>
            <div
              v-if="
                uploadingFile &&
                  (uploadingFile.status == 'prepar' ||
                    uploadingFile.status == 'uploading' ||
                    uploadingFile.status == 'success')
              "
              class="videoList"
            >
              <el-progress :percentage="uploadingFile.progress"></el-progress>
            </div>
          </div>
          <div
            class="coverImg"
            v-if="IsUploadSuccess">
            <video
              id="video"
              height="80"
              width="142"
              :src="coverImg"></video>
            <div class="delete">
              <i
                class="el-icon-delete"
                @click="deleteVideo"></i>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <p class="item_title">
            <span>*</span>
            {{ $t("lang.name") }}
          </p>
          <el-input
            v-model.trim="name"
            autocomplete="off"
            size="small"
            :maxlength="125"
            :placeholder="$t('lang.name')"
          ></el-input>
          <p class="item_title">
            <span>*</span>
            {{ $t('lang.setType') }}
          </p>
          <el-select
            v-model="setType"
            placeholder=" ">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <span :class="selectClass(item.value)"></span>
              <span style="float: left; color: #8492a6; font-size: 13px">{{
                item.label
              }}</span>
            </el-option>
          </el-select>
          <div v-show="false">
            <video
              id="videoMp4"
              disablePictureInPicture
              :featuresFullscreenResize="true"
              x5-playsinline=""
              playsinline=""
              webkit-playsinline=""
              class="videoTv video-js vjs-default-skin vjs-big-play-centered"
              controls="controls"
              name="media"
              muted="muted"
              preload="auto"
              loop
              :notSupportedMessage="$t('lang.canntPlay')"
            >
              <source
                :src="videoSrc"
                type="video/mp4" />
            </video>
          </div>
        </el-col>
      </el-row>
    </div>
    <span
      slot="footer"
      class="dialog-footer">
      <el-button
        class="save"
        @click.stop="save"
        :disabled="!(canAdd && IsUploadSuccess)"
      >{{ $t("lang.add") }}</el-button
      >
      <el-button
        class="cancel"
        @click="cancelUploadedVideo">{{
          $t("lang.cancel")
        }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
/*
 * 上傳视频本地测试有两处地址需要修改
 * 2.在UploadVideoForm.vue中将href字段修改
 * 以上都有注释 想要本地上传亚马逊测试的自我查看
 *
 * 上传亚马逊的基本思路为
 * ***
 * 1.调用后端接口,获取需要上传到亚马逊的数据(从后台获取亚马逊需要的数据)
 * 2.提交数据到亚马逊之后,亚马逊会自动刷新当前form表单的页面,刷新后 将form表单所在页面的url改变,将我们需要的字段通过url返回给我们
 * (后台通过这些字段可以找到当前上传视频所在亚马逊的位置及视频信息)
 * 3.获取到url中的信息后 将获取信息通过接口发送给后端 完成上传
 *
 * */
import AWS from 'aws-sdk'
import Bus from '@/assets/js/vueBus.js'
import { mapState } from 'vuex'
import { playoutAnalyze } from '@/assets/js/googleAnalyze/playout.js'
import toTips from '@/assets/js/toTipsObj'
export default {
  props: {
    data: Object,
    edit: Boolean,
    editData: Object,
    session: String
  },
  computed: mapState({
    State: (state) => state,
    pageRequest: (state) => state.websocket.pageRequest
  }),
  data () {
    return {
      // 视频文件列表配置
      mediaListProps: {
        label: 'name',
        children: 'sonFileInfo'
      },
      awsInfo: {
        bucket: '',
        region: ''
      },
      canAdd: false,
      floderList: [],
      floderName: '',
      name: '',
      clipId: '',
      houseId: '',
      options: [
        {
          value: 'break',
          label: 'Break'
        },
        {
          value: 'clip',
          label: 'Clip'
        }
      ],
      setType: 'break',
      fileParam: {
        pageNum: 1,
        pageSize: 15,
        condition: '',
        sessionId: localStorage.getItem('channelSession')
      },
      times: '',
      videoSrc: '',
      tinr: '',
      onceChange: true,
      sameVideo: '',
      imgAccept:
        '.ts,.rm,.rmvb,.wmv,.wtv,.avi,.3gp,.mkv,.mpg,video/mpeg,video/mp4,.mov',
      uploadingFile: null,
      fileList: [],
      floderLocalName: '',
      uploadObj: {},
      fileId: '',
      loadFlag: false,
      objctKey: {},
      flodLocation: '',
      showTreeFlag: false,
      mediaList: [],
      queryRgion: true,
      userSessionId: '',
      // 是否上传成功
      IsUploadSuccess: false,
      // 上传视频预览封面
      coverImg:
        'https://pp-va-001.s3.amazonaws.com/362881b36f554796a15f43aadb877f4b/Images/Playout/calling-7.png'
    }
  },
  created () {
    // const awsInfo = {
    //   bucket: this.State.common.baseUrl.awsRegionalInfo.bucket,
    //   region: this.State.common.baseUrl.awsRegionalInfo.region
    // }
    // this.awsInfo = Object.assign({}, awsInfo)
    // Bus.$on('sameVideoInfoScu', (result) => {
    //   console.log(result)
    // })
  },
  mounted () {
    this.onceChange = true
    window.document.addEventListener('click', (event) => {
      if (
        !(
          $('.flodTree')[0] == event.target ||
          ($('.flodTree')[0] && $('.flodTree')[0].contains(event.target)) ||
          $('.treeInput')[0] == event.target ||
          ($('.treeInput')[0] && $('.treeInput')[0].contains(event.target))
        )
      ) {
        this.showTreeFlag = false
      }
    })
    this.objctKey.id = this.data.parentId
  },
  methods: {
    showTree () {
      this.showTreeFlag = true
      this.showList()
    },
    // 点击复选框时
    getCheckedKeys (current, checked) {
      let isChoose = false
      checked.checkedKeys.forEach((item) => {
        if (item != current.id) {
          this.$refs.tree.setChecked(item, false)
        } else {
          isChoose = true
        }
      })
      if (isChoose) {
        this.flodLocation = current.name
        this.objctKey = current
      } else {
        this.flodLocation = ''
        this.objctKey = {}
      }
      this.showTreeFlag = false
      this.$message({
        type: 'success',
        message: this.$t('lang.success')
      })
    },
    showList () {
      const url = '/gatewayPlayoutUrl/tvu-playout/playoutfolderNew/getFolders'
      const fileParam = {
        pageNum: 1,
        pageSize: 1000,
        bucketCode: this.$store.state.buketId,
        queryRgion: true
      }
      this.axios.post(url, fileParam, {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result.length > 0) {
            const folderList = this.FilterFolder(res.data.result)
            this.mediaList = folderList
            this.$nextTick(() => {
              this.$refs.tree.setChecked(this.objctKey.id, true)
            })
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    },
    // 过滤文件夹
    FilterFolder (folderList) {
      let FileList = []
      const ProgramRMessage = localStorage.getItem('ProgramRMessage')
      let showFolders
      if (ProgramRMessage) {
        showFolders = JSON.parse(ProgramRMessage).showFolders
      }
      if (showFolders) {
        showFolders = showFolders.toUpperCase()
        const folderNameList = showFolders.split(',')
        // 筛选要显示的文件夹
        FileList = folderList.filter((item) => folderNameList.includes(item.name.toUpperCase()))
        return FileList
      }
      const { urlInfo } = JSON.parse(localStorage.getItem('channelInitConfig'))
      if (urlInfo.folderNameList) {
        const folderName = urlInfo.folderNameList.toUpperCase()
        console.log(folderName)
        const folderNameList = folderName.split(',')
        // 筛选要显示的文件夹
        FileList = folderList.filter((item) => folderNameList.includes(item.name.toUpperCase()))
      }
      return FileList
    },
    cancelUploadedVideo () {
      if (
        this.uploadObj &&
        this.uploadingFile &&
        (this.uploadingFile.status == 'uploading' ||
          this.uploadingFile.status == 'prepar' ||
          this.uploadingFile.status == 'success')
      ) {
        this.$refs.loadControl.abort()
        this.uploadObj.abort()
      }
      this.remoteMethod()
      this.clear()
      playoutAnalyze('playoutVideoCancel', '/po')
    },
    saveVideoInfo () {
      const timestamp3 = new Date().getTime()
      this.houseId =
        this.name.slice(0, 4).toUpperCase() + this.formatDate(timestamp3)
      const param = {
        folderId: this.objctKey.id, // this.floderName
        nickName: this.name,
        name: this.name,
        fileType: 2,
        clipId: this.clipId,
        houseId: this.houseId,
        setType: this.setType,
        videoTimes: this.times.toFixed(3),
        fileId: this.fileId
      }
      this.axios
        .post('/gatewayPlayoutUrl/tvu-playout/fileInfoNew/add', param, {
          contentType: 'application/json;charset=UTF-8'
        })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.clear()
            this.$emit('queryList', 'save')
            Bus.$emit('updateMediaList')
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
          } else if (res.data.errorCode == '80600700') {
            this.$message({
              type: 'warning',
              message: this.$t('lang.serverFailed')
            })
          } else {
            this.$message({
              type: 'info',
              message: res.data.errorInfo
            })
          }
        }).catch()
    },
    save () {
      if (!this.flodLocation) {
        this.$message.info('Please select floder')
        return
      }
      if (!this.name || (this.name && this.name.length < 4)) {
        this.$message.info(this.$t('lang.extSourceNameTips'))
        return
      }
      if (this.name.indexOf('/') >= 0) {
        this.$message.info(`"/" ${this.$t('lang.extSourceNameTips')}`)
        return
      }
      // if (!this.clipId) {
      //     this.$message.error('Please enter clipId');
      //     return;
      // }
      if (this.uploadingFile && this.uploadingFile.status != 'filesuccess') {
        this.$message.info(this.$t('lang.waitFileUpload'))
        return
      }
      if (!this.uploadingFile || this.uploadingFile.status != 'filesuccess') {
        return
      }
      this.saveVideoInfo()
      playoutAnalyze('playoutVideoAdd', '/po')
    },
    remoteMethod () {
      this.floderName = ''
      this.name = ''
      this.clipId = ''
      this.houseId = ''
    },
    // 删除上传的视频
    deleteVideo () {
      this.fileList = []
      this.canAdd = false
      this.IsUploadSuccess = false
    },
    clear () {
      this.fileList = []
      this.uploadObj = {}
      this.uploadingFile = null
      this.data.show = false
      this.canAdd = false
      this.IsUploadSuccess = false
      this.objctKey = {}
      this.flodLocation = ''
    },
    // 获取视频长度1
    getVideoTime (i) {
      this.onceChange = false
      if (i) {
        const vdo = document.getElementById('videoMp4')
        vdo.src = i
        vdo.load()
        vdo.play()
        if (this.tinr) clearInterval(this.tinr)
        this.tinr = setInterval(() => {
          if (!isNaN($('#videoMp4')[0].duration)) {
            this.times = $('#videoMp4')[0].duration
            clearInterval(this.tinr)
            this.canAdd = true
          }
        }, 1000)
        setTimeout(() => {
          clearInterval(this.tinr)
          if (!this.times) {
            this.times = 0
            this.canAdd = false
          }
        }, 5000)
      }
    },
    // 获取视频长度
    getVideoTimeNew () {
      const file = this.uploadingFile.raw
      const video = document.createElement('video')
      video.preload = 'metadata'
      video.onloadedmetadata = () => {
        let url = video.src
        if (url.startsWith('blob:')) {
          url = url.substr(5)
        }
        window.URL.revokeObjectURL(url)
        const { duration } = video
        console.log(`视频长度为：${duration}`)
        this.times = video.duration
        this.canAdd = true
      }
      video.src = URL.createObjectURL(file)
      this.coverImg = video.src
    },
    selectClass (i) {
      if (i == 'clip') {
        return 'yellow'
      } else {
        return 'zise'
      }
    },
    handleChange (file) {
      if (this.flodLocation == '' || this.fileList.length > 0) return false
      this.uploadingFile = file
      this.uploadingFile.progress = 0
      this.uploadingFile.status = 'prepar'
      this.fileList = [this.uploadingFile]
      this.getVideoTimeNew()
    },
    handleRemove (file, fileList) {
      this.fileList = fileList
      this.clear()
    },
    async queryParentId () {
      const param = {
        userId: localStorage.getItem('userId'),
        programId: this.$BehaviorSyns.getProgramId()
      }
      await this.axios
        .post('/gatewayPlayoutUrl/tvu-playout/playoutfolderNew/queryParentId', param)
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.userSessionId = res.data.result.session
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch()
    },
    async uploadFileBySDK () {
      const roleId = localStorage.getItem('roleId')
      const params = {
        region: this.$store.state.region
          ? this.$store.state.region
          : this.awsInfo.region, // 选中的region
        service: 'pp',
        directoryName: this.objctKey.objectKey
          ? this.objctKey.objectKey
          : `/${this.floderLocalName}`,
        fileName: this.uploadingFile.name
      }
      // 名字为空填充
      if (!this.name) {
        this.name = this.uploadingFile.name
      }
      await this.queryParentId({ userId: localStorage.getItem('userId') })
      this.$http
        .post('/file/request-upload-for-sdk', params, {
          requestBase: 'GATEWAY',
          sessionRoleId: this.userSessionId
        })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.loadFlag = true
            const { result } = res.data
            AWS.config.region = result.identityPoolRegion
            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
              IdentityPoolId: result.identityPoolId
            })
            this.doUploadFile(result)
          }
        }).catch()
    },
    doUploadFile (obj) {
      this.uploadObj = new AWS.S3.ManagedUpload({
        params: {
          // Bucket: this.$store.state.buketId? this.$store.state.buketId : this.awsInfo.bucket,
          Bucket: obj.bucket,
          Key: obj.objectKey,
          Body: this.uploadingFile.raw,
          ACL: 'public-read' // 固定
        },
        service: new AWS.S3({
          region: obj.region
        })
      })
      this.uploadObj.on('httpUploadProgress', (event) => {
        this.uploadingFile.progress = Math.floor(
          (event.loaded * 100) / event.total
        )
        this.uploadingFile.status = 'uploading'
        if (this.uploadingFile.progress == 100) {
          this.uploadingFile.progress = 99
        }
        this.$set(this.fileList, 0, this.uploadingFile)
      })
      this.uploadObj.promise().then((data) => {
        this.saveResult(obj, data)
      })
    },
    saveResult (obj, data) {
      // let driveId = obj.objectKey.split('/')[0]
      // let params = {
      //   name: obj.fileName,
      //   driveId: driveId,
      //   bucketId: obj.bucketId,
      //   isDirectory: false,
      //   objectKey: obj.objectKey
      // };
      const params = {
        bucketId: obj.bucketId,
        directoryId: obj.directoryId,
        objectKey: obj.objectKey
      }
      this.axios
        .post('/file/add-file', params, { requestBase: 'GATEWAY' })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.loadFlag = false
            this.fileId = res.data.result
            this.uploadingFile.progress = 100
            // 视频上传成功
            this.IsUploadSuccess = true
            this.uploadingFile.status = 'filesuccess'
          } else {
            this.uploadingFile.status = 'failed'
            this.loadFlag = false
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch()
    },
    formatDate (data) {
      const now = new Date(data)
      const year = now.getFullYear()
      let month = now.getMonth() + 1
      let date = now.getDate()
      // let hour = now.getHours();
      // let minute = now.getMinutes();
      // let second = now.getSeconds();
      month = parseInt(month) < 10 ? `0${month}` : month
      date = parseInt(date) < 10 ? `0${date}` : date
      return `${date}${month}${year}`
    }
  },
  beforeDestroy () {
    this.clear()
    this.remoteMethod()
  }
}
</script>
<style lang="less" scoped>
.CoverWrap {
  position: relative;
  .coverImg {
    position: absolute;
    top: 25px;
  }
  .delete {
    position: absolute;
    top: 0px;
    width: 142px;
    height: 80px;
    background: rgba(0, 0, 0, 0.5);
    text-align: center;
    line-height: 80px;
  }
}
/deep/ .is-disabled {
  span {
    color: #666;
  }
}

.opcaty {
  opacity: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

/deep/ .el-upload__input {
  display: none;
}

.add-source-dialog .content {
  height: 230px !important;

  /deep/ .floder_list.el-select {
    width: 520px;
    height: 36px;
    margin-bottom: 9px;
    position: relative;

    .el-input {
      height: 100%;
    }

    input {
      width: 100%;
      height: 100%;
    }
  }
}

.videoList {
  width: 142px;
  height: 80px;
  background: rgba(40, 71, 48, 1);
  border: 1px solid rgba(40, 71, 48, 1);
  position: absolute;
  top: -1px;
  left: -1px;

  .editName {
    height: 30px;
    width: 100%;

    /deep/ .el-input__inner {
      width: 100% !important;
      height: 30px !important;
      background: #333333 !important;
      border: none !important;
    }
  }
  /deep/.el-progress {
    height: 100%;
    position: relative;
    .el-progress__text {
      position: absolute;
      left: 50%;
      top: 40%;
      transform: translate(-50%, -50%);
      font-size: 18px;
      color: #fff;
    }
    .el-progress-bar {
      position: absolute;
      bottom: 10px;
      left: 5px;
      .el-progress-bar__outer {
        width: 132px;
      }
    }
  }
  .waitThumbneil:hover .delete {
    display: block;
  }

  .waitThumbneil {
    height: 106px;
    line-height: 106px;
    text-align: center;
    background: rgba(44, 44, 44, 1);
    position: relative;
    font-size: 24px;
    color: #318f47;

    .videoThumbneil {
      width: 100%;
      height: 100%;
    }

    i {
      cursor: pointer;
    }

    .delete {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 16px;
      color: white;
      background: rgba(2, 0, 3, 0.1);
      display: none;
      z-index: 2;

      i {
        cursor: pointer;
      }
    }

    .timeInfo {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 30px;
      line-height: 30px;
      text-align: right;
      color: white;
      font-size: 0.12rem;
      padding: 0 10px;
      z-index: 1;
    }
  }

  .videoName {
    height: 30px;
    line-height: 30px;
    text-align: center;
    width: 100%;
    padding: 0 10px;
    color: #6b6b6b;
    background: #333333;
    margin-top: 4px;
  }
}

.item_title {
  font-size: 14px;
  font-weight: 400;
  color: rgba(223, 223, 223, 1);
  margin-bottom: 5px;

  span {
    color: red;
  }
}

.upload_p {
  width: 142px;
  height: 80px;
  border: 1px dashed #3a3a3a;
  line-height: 80px;
  position: relative;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  color: rgba(223, 223, 223, 1);

  .upload {
    position: absolute;
    top: 0;
    left: 0;
    /*width: 142px!important;*/
    height: 80px;
    cursor: pointer;

    /deep/ .el-upload {
      width: 142px !important;
      height: 80px;
      opacity: 0;
    }

    /deep/ .el-upload-list {
      width: 140px;
      opacity: 1;
      color: #fff !important;
      margin-top: -45px;
      /deep/ .el-progress {
        display: none;
      }
      /deep/ .el-upload-list__item-name {
        color: #ffffff;
        margin-right: 20px;
      }

      /deep/ .el-icon-close {
        display: block;
        color: white;
      }
    }

    /deep/ .el-upload-list__item:hover {
      background-color: #252525;
    }
    &.notAllowed {
      cursor: not-allowed;
      /deep/.el-upload {
        cursor: not-allowed;
      }
    }
  }
}

.add-source-dialog {
  .content {
    text-align: left;
    font-size: 16px;
    height: 200px;
    max-height: 55vh;
    // overflow-y: auto;

    .item {
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }

      span {
        display: block;
        margin-bottom: 5px;
      }
    }

    /deep/ .el-input .el-input__inner {
      border: 1px solid #444;
      background: #444;
      height: 46px;
      line-height: 46px;
      color: white !important;

      &::-webkit-input-placeholder {
        color: #666;
      }
    }

    /deep/ .select-box {
      width: 100%;

      .el-input__inner {
        border: 1px solid #444;
        background: #444;
        height: 46px;
        line-height: 46px;
      }
    }

    /deep/ .el-select {
      width: 100%;

      .el-select__input {
        color: #fff;
      }
    }

    /deep/ .selectRlist {
      width: 100%;
      height: 300px;
      overflow-y: auto;
    }
  }
}

.delete {
  width: 120px;
}

.yellow {
  background: #ffc573;
  float: left;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  margin-top: 6px;
  margin-right: 10px;
}

.zise {
  background: #9248c7;
  float: left;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  margin-top: 6px;
  margin-right: 10px;
}

.flodTree {
  width: 510px;
  height: 190px;
  background: #444;
  position: absolute;
  z-index: 9999;
  border-radius: 2px;
  overflow-y: auto;
  margin-top: 5px;
  ::v-deep .el-tree{
    overflow: hidden;
  }
  /deep/.el-tree-node__content > .el-tree-node__expand-icon {
    padding: 1px;
  }
  /deep/.el-tree-node__content {
    height: 30px;
    line-height: 30px;
  }
  /deep/.el-checkbox {
    margin-bottom: 0px !important;
    margin-right: 5px !important;
  }
}
</style>
